import * as types from './types';

export const setHeaderTitle = (payload) => {
  return { type: types.HEADER_TITLE, payload };
};

export const showBackButton = () => {
  return { type: types.HEADER_BACK_BUTTON, payload: true };
};

export const hideBackButton = () => {
  return { type: types.HEADER_BACK_BUTTON, payload: false };
};



// WEBPACK FOOTER //
// ./src/actions/header/headerActions.js